var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('confirm-dialog',{attrs:{"title":"バインダーから削除","confirm-label":"削除する"},on:{"confirm":_vm.removeBookmark},model:{value:(_vm.deleteBookmarkDialog),callback:function ($$v) {_vm.deleteBookmarkDialog=$$v},expression:"deleteBookmarkDialog"}})
}
var staticRenderFns = []

export { render, staticRenderFns }